import React from "react";
import { Navigate } from "react-router-dom";
import { getHasJWT } from "@/helpers/auth";
import { useAuth } from "@/hooks/useAuth";
import { paths } from "@/router/paths";

interface IProps {
  render: React.ReactNode;
  guest?: boolean;
  to?: string;
}

const RouteGuard: React.FC<IProps> = ({ render, guest = false, to }) => {
  const hasJWT = getHasJWT();
  const { workspace } = useAuth();

  if (
    !workspace &&
    hasJWT &&
    !window.location.href.includes(paths.auth.workspaces)
  ) {
    return <Navigate to={{ pathname: paths.auth.workspaces }} />;
  }
  if (guest ? !hasJWT : hasJWT) return <>{render}</>;
  if (!to) return null;
  return <Navigate to={{ pathname: to }} />;
};

export default RouteGuard;
